define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const device = require('util/device.util');
    const DepositMethodView = require('portlets/cashier/deposit/deposit.method.view');
    const PaymentButtonMethodView = require('portlets/cashier/deposit/special/paymentbutton-deposit.method.view');
    const core = require('core');
    const cashierUtil = require('modules/cashier/cashier.util');
    const i18n = require('i18n');
    const CashierMethodView = require('portlets/cashier/swiss-theme/cashier.method.view');

    let initializing = false;

    require('widgets/suggestions.widget');

    module.exports = DepositMethodView.extend({

        popup: null,

        events: {
            ...DepositMethodView.prototype.events,
            'change input[name="amount"]': 'onAmountChange',
            'tap .fn-one-suggestion': 'alignmentLabel',
            'tap .fn-change-account': 'addAnotherAccount',
            'tap .fn-icon-iban': 'clickToCopy'
        },

        clickToCopy: function(e) {
            const parent = e.target.parentElement;
            if (parent.className.includes('copy-iban')) {
               let selected = false;
               const el = document.createElement('textarea');
               el.value = parent.innerText;
               el.setAttribute('readonly', '');
               el.style.position = 'absolute';
               el.style.left = '-9999px';
               document.body.appendChild(el);
               if (document.getSelection().rangeCount > 0) {
                   selected = document.getSelection().getRangeAt(0);
               }
               el.select();
               document.execCommand('copy');
               document.body.removeChild(el);
               if (selected) {
                   document.getSelection().removeAllRanges();
                   document.getSelection().addRange(selected);
               }
            }
        },

        addAnotherAccount: function(e) {
            CashierMethodView.prototype.addAnotherAccount.apply(this, arguments);

            if (this.model.get('code') === 'DotpayBlik') {
                var $bank = this.$('.fn-bank');
                $bank.html('');
            }

            this.handleAccountChange(e.target.value);
        },

        onAmountChange: function() {
            const amount = this.form.data('amount');

            if (!amount) {
                $('.fn-deposit-method').removeClass('blockDepositPMClick');
                return Promise.resolve(this._paymentButtonView?.$el);
            }
        },

        render: function() {
            const code = this.model.get('code');
            const isApple = code.includes('ApplePayDT');
            const isGoogle = code.includes('GooglePayDT');
            const isSafari = device.browserName === 'safari';
            let isAllowed = true;

            if (isApple && isSafari) {
                isAllowed = isSafari;
                this.showLoader();

                this.checkPaymentButton()
                    .then(() => this._paymentButtonView.supported
                            ? DepositMethodView.prototype.render.apply(this, arguments)
                            : this.$el.parents('.payment-method').remove());
            } else if (isApple && !isSafari) {
                this.$el.parents('.payment-method').remove();
            } else if (isGoogle) {
                this.$el.parents('.payment-method').remove();
            } else {
                isAllowed
                    ? DepositMethodView.prototype.render.apply(this, arguments)
                    : this.$el.parents('.payment-method').hide();
            }

            return this;
        },

        checkPaymentButton: function() {
            return new Promise(function(resolve, reject) {
                this._paymentButtonView = new PaymentButtonMethodView({
                    form: this.form,
                    model: this.model
                });

                this._paymentButtonView.depositAndRender()
                    .then(() => resolve(), () => reject());
            }.bind(this));
        },

        alignmentLabel: function() {
            const label = this.form.el.querySelector('.floating-label');
            const aboveClass = 'label-above';
            const isAboveLabel = label.classList.contains(aboveClass);
            !isAboveLabel && label.classList.add(aboveClass);
        },

        showLoader: function() {
            this.el.childNodes.forEach(function(child) {
                !child.classList.contains('fn-loader') && $(child).hide();
            });
            !this.$el.find('.fn-loader').length && this.$el.append($(this.tmpl('common.loader')));
        },

        hideLoader: function() {
            this.$el.find('.fn-loader').hide();
            this.el.childNodes.forEach(function(child) {
                !child.classList.contains('fn-loader') && $(child).show();
            });
        },

        waitForPaymentButton: (ms = 200) => new Promise((resolve) => {
            const interval = setInterval(() => {
                if (!initializing) {
                    resolve();
                    clearInterval(interval);
                }
            }, ms);
        }),

        depositAction: function(options) {
            var extWindow;

            return this.form.validate().done(function(data, form) {

                if (this.model.get('reDirectType') === 'popup') { // Safari `window.open` hack
                    extWindow = window.open('', '', 'resizable=yes, width=800px, height=600px');
                }

                data = _.extend({}, data, options);

                this.hideKeyboard();
                form.showLoading();

                data = this.model.resolveStoredAccount(data);

                this.model.deposit(data)
                    .always(response => {
                        this._handleClearSecureFields(response);
                        this._handleClearPromoCode(response, data);
                    })
                    .then(response => this.successDeposit(response, extWindow))
                    .fail(error => this.errorDeposit(data, error, extWindow))
                    .always(() => form.hideLoading());
            }.bind(this));
        },

        successDeposit: function(response) {
            const deferred = $.Deferred();
            const resolve = deferred.resolve.bind(deferred);

            if (this.model.get('reDirectType') === 'paymentbuttondt') {
                this.renderPaymentButtonPopup(response).then(resolve);

                return deferred;
            }

            return DepositMethodView.prototype.successDeposit.apply(this, arguments);
        },

        errorDeposit: function(data, response, extWindow) {
            extWindow && extWindow.close();

            if (!response) {
                this.form.showErrorMessage({
                    translation: 'playtech.mobile.system.error.no.response'
                });

                return;
            }

            var errorMessage = response.data.errorMessage
                || response.data.error && response.data.error.message
                || null;

            // Currency conversion, fee, 1st deposit confirmation
            var knownError = this.handleError(response.data.error);

            if (knownError) {
                var modelId = this.model.id || '';
                data[knownError.type] = true;

                if (knownError.type === 'depositConfirmed' && cashierUtil.isPekoResponse(response)) {
                    errorMessage = response.data.error && response.data.error.message || null;
                }

                window.Playtech.API.popup.showPopup('confirmation', {
                    isModal: false,
                    title: modelId === 'PaySafeCardDT' ? i18n.t('playtech.mobile.system.deposit.PaySafeCardDTFee') : response.data.error.severity || 'Warning',
                    content: errorMessage,
                    onAccept: () => this.depositAction(data),
                    onDecline: () => this._clearSecureFields()
                });

            } else {
                var pekoErrorMessage = cashierUtil.getErrorMessage(response);

                if (pekoErrorMessage) {
                    this.form.showErrorMessage({
                        content: pekoErrorMessage
                    });
                } else {
                    this.form.showErrorMessage({
                        translation: 'playtech.mobile.system.mobile-cashier.error.' + response.data.errorCode,
                        content: errorMessage
                    });
                }
            }

            this.handleSpecialPmsDepositError(data, response);

            core.trigger('deposit:fail', response.data);
        },

        renderPaymentButtonPopup: function(response) {
            return this.renderPaymentButton(response).then(function() {
                window.Playtech.API.popup.showPopup({
                    id: 'applePayPopup',
                    layer: 'APPLE_POPUP',
                    className: 'swiss-lightbox-popup',
                    content: `<hub2-datatrans-pm-popup />`,
                    buttons: false,
                    closeAll: true,
                    onClose: () => this._paymentButtonView.close.bind(this._paymentButtonView)
                });

                setTimeout(() => {
                    const content = $('.popup-modal__content-inner.fn-popup-loader.fn-popup-content');
                    content.append(this._paymentButtonView.el);
                }, 100);
            }.bind(this));
        },

        renderPaymentButton: function(response) {
            if (this._paymentButtonView) {
                return this._paymentButtonView.handleButton(response);
            }

            this._paymentButtonView = new PaymentButtonMethodView({
                form: this.form,
                model: this.model
            });

            return this._paymentButtonView.handleButton(response);
        }
    });
});
